import { memo, ReactNode } from 'react';
import { Alert, Typography, AlertColor } from '@mui/material';

export interface StatusAlertProps {
  severity: AlertColor;
  title: string;
  body: ReactNode;
  action?: ReactNode;
}

export const StatusAlert = memo<StatusAlertProps>(({ severity, title, body, action }) => (
  <Alert severity={severity} sx={{ mb: 3 }} action={action}>
    <Typography variant="subtitle2" fontWeight="bold">
      {title}
    </Typography>
    {typeof body === 'string' ? (
      <Typography variant="body2">{body}</Typography>
    ) : (
      body
    )}
  </Alert>
));

StatusAlert.displayName = 'StatusAlert';

export default StatusAlert;
